import styled from '@emotion/styled';

const PatientCardSectionLabel = styled.div`
    font-size: 14px;
    color: var(--brandPrimary);
    font-weight: bold;
    margin-bottom: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;

    &:hover {
        opacity: 0.8;
    }

    .caret-icon {
        margin-right: 8px;
        transition: transform 0.2s ease;
        color: var(--manatee);

        &.expanded {
            transform: rotate(90deg);
        }
    }
`;

export default PatientCardSectionLabel;
